export default __webpack_public_path__ + "static/media/grabit_blanco-03.a0fe475d.svg";